import React, {Component} from 'react'
import RaspaRecipeDashboardView from "./RaspaRecipeDashboardView";





class RaspaRecipeDashboard extends Component {


    render() {

        return (
            <RaspaRecipeDashboardView/>
        )
    }
}



export default (RaspaRecipeDashboard);